var Artiste_Intro = {
    init: function () {
        $(".artiste-intro .read-more").on("click touchend", function (e) {
            e.preventDefault();
            e.stopPropagation();

            if (e.type == 'touchend') {
                $(this).off("click");
            }
            Artiste_Intro.open_more();

        });

        $(".artiste-intro .read-less").on("click touchend", function (e) {
            e.preventDefault();
            e.stopPropagation();

            if (e.type == 'touchend') {
                $(this).off("click");
            }
            Artiste_Intro.close_more();
        });


        var hash = window.location.href.split('#').pop();
        ;

        console.log(hash);

        if (hash == "read-more") {
            Artiste_Intro.open_more(true);
        }

    },
    open_more: function (no_scroll) {

        $(".artiste-intro .artiste-more").css({height: $(".artiste-intro .more-content").innerHeight()})

        $(".artiste-intro .artiste-more").addClass("open");
        $(".artiste-intro").addClass("open");
        if (no_scroll != true) {
            $('html, body').animate({scrollTop: $(".artiste-intro .artiste-more").offset().top}, 500);
        }
    },
    close_more: function () {
        $(".artiste-intro .artiste-more").css({height: 0})
        $(".artiste-intro .artiste-more").removeClass("open");
        $(".artiste-intro").removeClass("open");
    }
}

$(window).load(function () {
    if ($(".artiste-intro").length) {
        Artiste_Intro.init();
    }
})